import React, { useContext, useEffect, useState } from 'react'

//styles
import "./ProductList.css"

//components
import ProductCard from '../productCard/ProductCard'
import { getAllCardsInventary } from '../../api/Products'
import { PromiseSesionContext } from '../../machines/ErrorMachine'
import { Product } from '../../models/Product'
import { useDebounce } from '../../hooks/useDebounce'
import SkeletonProduct from '../Skeleton/SkeletonProduct'
import { Pagination } from 'antd'
import EmptyList from '../EmptyList/EmptyList'

interface Props{
   loading:boolean
   setLoading:React.Dispatch<React.SetStateAction<boolean>>
   categories:string[]
   franchise:string[]
   status:string[]
   setTotal?: React.Dispatch<React.SetStateAction<number>>
}

const ProductList = ({loading, setLoading, status, categories, franchise, setTotal}:Props) => {
  const [allProducts, setAllProducts] = React.useState<Product[]>([]);
  const {sendError} = useContext(PromiseSesionContext);

  const debouncedCategory = useDebounce(categories, 700);
  const debouncedFranchise= useDebounce(franchise, 700);
  const debouncedStatus = useDebounce(status, 700);
    //paginate
    const [page, setPage] = useState<number>(1)
    const [limitPage, setLimitPage] = useState<number>(30)

    const [totalPage, setTotalPage] = useState<number>(0)
    const [totalElements, setTotalElements] = useState<number>(0)

    const getProducts = async ()=>{
        try{
        setLoading(true);
        const response =  await getAllCardsInventary(page, limitPage, "", categories.join(","), franchise.join(","), status.join(","))
        if(response.total!== totalElements){
          setPage(1)
        }
        setAllProducts(response.products)
        // setFilteredProducts(response.products); 
        setTotalPage(response.last_page)
        setTotalElements(response.total)
        if(setTotal){
          setTotal(response.total)
        }
        setLoading(false);
        }
        catch(error){
        setLoading(false);
        sendError({type: "ERROR", data:{message:"Error al cargar el inventario.", type:"error"}})

        }
    }
  
  useEffect(() => {
    getProducts()
  }, [page,debouncedCategory, debouncedFranchise, debouncedStatus ]);

  return (
    <>
    <EmptyList total={allProducts.length} loading={loading}>
      <div className='ProductListComponent'>
        <SkeletonProduct loading={loading}>
            {
              allProducts.map((product:Product) => 
              <ProductCard 
              key={product.id+" producto"} 
              bcvPrice={product.bcvPrice} 
              category={product.category.name}
              description={product.description}
              image={product.image}
              name={product.name} 
              location={product.location}
              franchise={product.franchise.name}/>)
            }
        </SkeletonProduct>
      </div>
    </EmptyList>

    <div className='centerPaginate'>
      {(totalPage>1 && !loading) && <Pagination defaultCurrent={page} onChange={(newPage, newPageSize)=>{setPage(newPage);window.scrollTo({ top: 0, behavior: 'smooth' });}} current={page} total={totalElements} pageSize={limitPage} showSizeChanger={false} />}
    </div>
    </>
  )
}

export default ProductList

